import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const ValidationDialog = ({ open, onClose, persons }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Inscription</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Votre inscription pour {persons} personne{persons > 1 && 's'} a bien été prise en compte.
          A bientôt au Mas La Font !
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Merci
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ValidationDialog;
